import {isProjectViewEnabled} from '../allspice.ts';
import {GET} from '../modules/fetch.ts';

const {appSubUrl, pageData} = window.config;

export function initIssueCommentHashChangeFixer() {
  window.addEventListener('hashchange', handleHashChange);
  handleHashChange();
}

async function updateHashForIssueComment(commentId: string, initialHash: string) {
  const repoOwner = pageData.repoOwner;
  const repoName = pageData.repoName;
  if (!repoOwner || !repoName) {
    return;
  }

  try {
    const nameHash = await loadIssueComment(repoOwner, repoName, commentId);
    if (!nameHash) {
      return;
    }
    // only update the hash if it hasn't changed
    if (window.location.hash === initialHash) {
      window.location.hash = `#diff-${nameHash}-issuecomment-${commentId}`;
    }
  } catch (e) {
    console.error(e);
  }
}

async function handleHashChange() {
  const initialHash = window.location.hash;
  if (initialHash === '') {
    return;
  }

  // if no dom element and the hash is an issuecomment, we need to load the correct hash
  const parts = window.location.hash.replace('#', '').split('-');

  if (parts.length === 2 && parts[0] === 'issuecomment') {
    await updateHashForIssueComment(parts[1], initialHash);
  } else if (parts.length === 4 && parts[2] === 'issuecomment') {
    await updateHashForIssueComment(parts[3], initialHash);
  }
}

type CommentFileInfo = {
  nameHash: string;
  subPath: string | null;
  treePath: string;
};

async function loadIssueComment(repoOwnerName: string, repoName: string, commentId: string): Promise<string | undefined> {
  const response = await GET(`${appSubUrl}/${repoOwnerName}/${repoName}/comments/${commentId}/treepath`);
  switch (response.status) {
    case 200:
      break;
    case 404:
      return;
    default:
      throw new Error(`failed to fetch treePath for comment`);
  }

  const data: CommentFileInfo = await response.json();
  let nameHash = data.nameHash;
  if (data.subPath && isProjectViewEnabled()) {
    nameHash = `${nameHash}_${data.subPath}`;
  }

  return nameHash;
}
